import { DrawPolygon } from '@pzh-ui/icons'
import { ZodIssueCode } from 'zod'

import {
    useGetRevisionsWerkingsgebiedVersion,
    useWerkingsgebiedEditObjectStatic,
    useWerkingsgebiedGetListActiveModuleObjects,
    useWerkingsgebiedListValidLineageTree,
    useWerkingsgebiedListValidLineages,
    useWerkingsgebiedPostModulePatchObject,
    useWerkingsgebiedViewGetObjectStatic,
    useWerkingsgebiedViewModuleObjectLatest,
    useWerkingsgebiedViewObjectLatest,
    useWerkingsgebiedViewObjectVersion,
} from '@/api/fetchers'
import { generateDynamicSchema } from '@/validation/dynamicObject'
import { schemaDefaults } from '@/validation/zodSchema'

import { DynamicObject } from './types'

const fetchers = {
    useGetValid: useWerkingsgebiedListValidLineages,
    useGetValidLineage: useWerkingsgebiedListValidLineageTree,
    useGetVersion: useWerkingsgebiedViewObjectVersion,
    useGetLatestLineage: useWerkingsgebiedViewObjectLatest,
    useGetRevision: useGetRevisionsWerkingsgebiedVersion,
    useGetRelations: null,
    usePutRelations: null,
    useGetLatestLineageInModule: useWerkingsgebiedViewModuleObjectLatest,
    usePatchObjectInModule: useWerkingsgebiedPostModulePatchObject,
    usePatchObject: null,
    useDeleteObject: null,
    useGetStatic: useWerkingsgebiedViewGetObjectStatic,
    usePostStatic: useWerkingsgebiedEditObjectStatic,
    useGetAcknowledgedRelations: null,
    usePostAcknowledgedRelations: null,
    usePatchAcknowledgedRelations: null,
    usePostObject: null,
    useGetActiveModules: useWerkingsgebiedGetListActiveModuleObjects,
}

const werkingsgebied: DynamicObject<typeof fetchers> = {
    defaults: {
        singular: 'werkingsgebied',
        singularReadable: 'werkingsgebied',
        singularCapitalize: 'Werkingsgebied',
        plural: 'werkingsgebieden',
        pluralReadable: 'werkingsgebieden',
        pluralCapitalize: 'Werkingsgebieden',
        prefixSingular: 'het',
        prefixPlural: 'de',
        prefixNewObject: 'Nieuw',
        demonstrative: 'dit',
        icon: DrawPolygon,
    },
    staticData: ['Owner_1_UUID', 'Owner_2_UUID'],
    fetchers,
    dynamicSections: [
        {
            fields: [
                {
                    name: 'Title',
                    label: 'Titel',
                    type: 'text',
                    required: true,
                    validation: schemaDefaults.title,
                },
                {
                    name: 'Description',
                    label: 'Omschrijving',
                    type: 'wysiwyg',
                    customMenuOptions: ['heading'],
                },
                {
                    name: 'Area_UUID',
                    label: 'Bron',
                    type: 'area',
                    placeholder:
                        'Zoek een werkingsgebied op naam of de naam van een versie',
                },
            ],
        },
    ],
    hasRelatedObjects: true,
}

werkingsgebied.validationSchema = generateDynamicSchema(
    werkingsgebied.dynamicSections
).superRefine(({ Title, Source_Title }: any, ctx) => {
    if (!!Source_Title && Title !== Source_Title) {
        ctx.addIssue({
            code: ZodIssueCode.custom,
            message:
                'De titel moet overeen komen met de titel van de gekozen bron',
            path: ['Title'],
        })
    }
})

export default werkingsgebied
